module.exports = __webpack_public_path__ + "img/logo-JUFEJUS-nuevo.933695b0.png";